import { Directive, ViewContainerRef, Input } from '@angular/core';

@Directive({
  selector: '[widgetHost]',
})
export class WidgetDirective {

  @Input() pageNumber: string;

  constructor(public viewContainerRef: ViewContainerRef) {
    console.log('viewContainerRef=', viewContainerRef);
  }

  public pageNumberAsString() {
    return this.pageNumber;
  }

}



// WEBPACK FOOTER //
// ./src/app/widget.directive.ts